import React from "react";
import "../styles/OrderStatus.css";

const OrderSuccess = () => {
    return (
        <div className="order-status-container">
            <img src="/images/payment-success.png" alt="결제 완료" className="order-status-img" />
            <p className="order-status-text">결제가 완료되었습니다! <br/> 이용해주셔서 감사합니다.</p>
        </div>
    );
};

export default OrderSuccess;
